import React, { useEffect } from "react";
import { ShieldCheck } from "lucide-react";
import { Seo } from "../components/Seo";
import { PageHeader } from "../components/PageHeader";
import { RewardsCta } from "./ToxDepositThankYou";

export default function NewClientDeposit() {
  useEffect(() => {
    const SRC = "https://js.stripe.com/v3/buy-button.js";
    if (!document.querySelector(`script[src="${SRC}"]`)) {
      const s = document.createElement("script");
      s.src = SRC;
      s.async = true;
      document.body.appendChild(s);
    }
  }, []);

  return (
    <div data-testid="new-client-deposit-page">
      <Seo
        title="New Client First Time Visit Deposit"
        description="Reserve your first visit with a $20 deposit, credited toward your treatment total."
        path="/new-client-deposit"
        noindex
      />
      <PageHeader
        overline="New Client First Time Visit Deposit"
        title="Secure your first visit"
        subtitle="Welcome! A small deposit reserves your spot — and it's yours to keep toward your treatment."
      />

      <section className="pb-24">
        <div className="max-w-xl mx-auto px-6 space-y-6">
          <div
            className="bg-white rounded-[2rem] p-8 md:p-10 border border-slate-100 text-center"
            data-testid="new-client-deposit-card"
          >
            <div className="mx-auto mb-5 h-14 w-14 rounded-full iri-gradient flex items-center justify-center">
              <ShieldCheck className="h-7 w-7 text-ink" strokeWidth={1.5} />
            </div>
            <p className="text-[#5C6664] leading-relaxed text-base">
              Secure your first visit by making your <strong className="text-ink">$20 deposit</strong>.
              This deposit is credited at your appointment and deducted from your total.
            </p>

            <div className="mt-8 flex justify-center" data-testid="new-client-deposit-button">
              <stripe-buy-button
                buy-button-id="buy_btn_1UQq6TIyeti9SUWdGEcjYC9L"
                publishable-key="pk_live_51PktQIIyeti9SUWdislfKXZ71T90gujrO2ePwUVLOvYHB3ErGVk87bREhChvcvCKkrQlVo8KEWsEq5vNXKKrBExn005lnRPaQy"
              ></stripe-buy-button>
            </div>

            <p className="mt-6 text-xs text-[#8A9492]">
              Payments are processed securely by Stripe. Questions? Call (586) 690-8693.
            </p>
          </div>

          <RewardsCta />
        </div>
      </section>
    </div>
  );
}
